import { RequiredQueryKeyFilter, createDefaultQueryKeysGenerator } from 'core/query/constants';

interface StatisticsDetailKeyFilter extends RequiredQueryKeyFilter {
  teamId?: number;
  tenant?: string;
  realmId?: string;
}

type StatisticsListKeyFilter = RequiredQueryKeyFilter;

export const statisticsQueryKeys = createDefaultQueryKeysGenerator<
  StatisticsListKeyFilter,
  StatisticsDetailKeyFilter
>({
  keyDataType: 'statistics',
});
